import React from "react";
import { Link } from "react-router-dom";

function FieldNoteHeader({ fieldNote }) {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="pd-header fieldnote-header">
      <div className="header-bottom">
        <Link
          to="/fieldnotes"
          className="fieldnote-back-link"
          onClick={scrollTop}
        >
          <i className="bi bi-arrow-left" aria-hidden="true" />
          Field Notes
        </Link>

        <h2 className="pd-title">{fieldNote.title}</h2>
        <p className="fieldnote-author-line">by {fieldNote.name}</p>
      </div>
    </div>
  );
}

export default FieldNoteHeader;
